// Angular Imports
import { Injectable } from '@angular/core';
import { SafeHtml } from "@angular/platform-browser";

// 3rd Party Imports
import { FaConfig, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconDefinition, IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';

import {
  faMagic as fasMagic,
  faCompass as fasCompass,
  faRegistered as faRegistered,
  faChalkboardUser as fasChalkboardUser,
  faSquareFull as fasSquareFull,
  faChampagneGlasses as fasChampagneGlasses,
  faQuoteRight as fasQuoteRight,
  faGhost as fasGhost,
  faReply as fasReply,
  faUserPen as fasUserPen,
  faParagraph as fasParagraph,
  faWandSparkles as fasWandSparkles,
  faSquarePlus as fasSquarePlus,
  faBarcode as fasBarcode,
  faNewspaper as fasNewspaper,
  faFloppyDisk as fasFloppyDisk,
  faLink as fasLink,
  faLinkSlash as fasLinkSlash,
  faPenToSquare as fasPenToSquare,
  faBookmark as fasBookmark,
  faGlobe as fasGlobe,
  faMicrochip as fasMicrochip,
  faReceipt as fasReceipt,
  faChartSimple as fasChartSimple,
  faRss as fasRss,
  faUserShield as fasUserShield,
  faAddressCard as fasAddressCard,
  faRobot as fasRobot,
  faTrashCan as fasTrashCan,
  faGraduationCap as fasGraduationCap,
  faInbox as fasInbox,
  faBoxArchive as fasBoxArchive,
  faLightbulb as fasLightbulb,
  faArrowUp as fasArrowUp,
  faBolt as fasBolt,
  faUser as fasUser,
  faUsers as fasUsers,
  faHome as fasHome,
  faGears as fasGears,
  faClockRotateLeft as fasClockRotateLeft,
} from '@fortawesome/free-solid-svg-icons';

import {
  faPaperPlane as farPaperPlane,
  faEnvelope as farEnvelope,
  faCopyright as farCopyright,
  faCircleQuestion as farCircleQuestion,
  faStar as farStar,
} from '@fortawesome/free-regular-svg-icons';

// Key corresponds to the icon name at FontAwesome, value is the icon definition from the import
export const fa = {
  "magic": fasMagic,
  "paper-plane": farPaperPlane,
  "compass": fasCompass,
  "registered": faRegistered,
  "chalkboard-user": fasChalkboardUser,
  "square-full": fasSquareFull,
  "champagne-glasses": fasChampagneGlasses,
  "quote-right": fasQuoteRight,
  "ghost": fasGhost,
  "reply": fasReply,
  "user-pen": fasUserPen,
  "envelope": farEnvelope,
  "paragraph": fasParagraph,
  "wand-sparkles": fasWandSparkles,
  "square-plus": fasSquarePlus,
  "barcode": fasBarcode,
  "newspaper": fasNewspaper,
  "floppy-disk": fasFloppyDisk,
  "link": fasLink,
  "link-slash": fasLinkSlash,
  "pen-to-square": fasPenToSquare,
  "star": farStar,
  "bookmark": fasBookmark,
  "globe": fasGlobe,
  "circle-question": farCircleQuestion,
  "microchip": fasMicrochip,
  "receipt": fasReceipt,
  "chart-simple": fasChartSimple,
  "rss": fasRss,
  "user-shield": fasUserShield,
  "address-card": fasAddressCard,
  "robot": fasRobot,
  "trash-can": fasTrashCan,
  "graduation-cap": fasGraduationCap,
  "inbox": fasInbox,
  "box-archive": fasBoxArchive,
  "lightbulb": fasLightbulb,
  "arrowUp": fasArrowUp,
  "bolt": fasBolt,
  "user": fasUser,
  "users": fasUsers,
  "home": fasHome,
  "gears": fasGears,
  "clock-rotate-left": fasClockRotateLeft,
};

export type FontAwesomeIcons = typeof fa;

@Injectable({
  providedIn: 'root'
})
export class FontawesomeService {

  /**
   * Creates an instance of FontawesomeService.
   *
   * @constructor
   * @param {FaConfig} faConfig
   * @param {FaIconLibrary} library
   */
  constructor(
    private faConfig: FaConfig,
    private library: FaIconLibrary,
  ) {
    this.faConfig.fixedWidth = true;
    this.faConfig.fallbackIcon = fasMagic;
  }


  /**
   * Add all icons in 'fa' to the library, called in main.ts by the app initializer
   * 
   * @function addIcons
   * @return {void}
   */
  addIcons(): void {
    for (const key in fa) {
      if (fa.hasOwnProperty(key)) {
        try {
          this.library.addIcons(fa[key as keyof FontAwesomeIcons]);
        } catch (error) {
          console.error(`Error adding icon ${key} to library: ${error}`);
        }
      }
    }
  } // addIcons

  show(icon: string): [IconPrefix, IconName] {
    const iconDefinition = fa[icon as keyof typeof fa];

    if (iconDefinition) {
      return [iconDefinition.prefix, icon] as [IconPrefix, IconName];
    } else {
      return ["fas", "magic"] as [IconPrefix, IconName];
    }


  }

  iconToSvg(icon: IconDefinition = fa.home, width?: number, height?: number): SafeHtml {
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${width || 20}" height="${height || 20}" viewBox="0 0 384 512"><path d="${icon.icon[4].toString()}" /></svg>`;
  }
}
